const createMailActionLink = (sendTo, subject, body) => {
    return `mailto:${sendTo}?subject=${subject}&body=${body}`;
}

export {createMailActionLink}